import { render, staticRenderFns } from "./SearchPagination.vue?vue&type=template&id=4b132931&"
import script from "./SearchPagination.vue?vue&type=script&lang=js&"
export * from "./SearchPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports